import { getAppInfo } from './interfaces';
export function getAragonOsInternalAppInfo(appId) {
    return getAppInfo(appId, 'aragon');
}
export function getApmInternalAppInfo(appId) {
    return getAppInfo(appId, 'apm');
}
export { hasAppInfo, getAppInfo } from './interfaces';
//# sourceMappingURL=index.js.map